import React, { useState, useEffect } from 'react'
import moment from 'moment-timezone'
import { useDispatch } from 'react-redux'
import { Divider, Radio, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'

import { Button3 } from 'components'
import moneyConvert from 'utils/moneyConvert'

import { getListPayment } from 'apis'

import * as S from './style'
import * as T from '../TableCompany/style'
interface Props {
  onClick?: any
  className?: any
  children?: any
}

interface DataType {
  key: React.Key
  date: string
  money: number
  address: string
}

const columns: ColumnsType<DataType> = [
  {
    title: '주간 출금 TOP10',
    dataIndex: 'name',
    width: '50%'
    // render: (text: any) => <span>****</span>,
  },
  {
    title: ' ',
    dataIndex: 'money',
    width: '20%',
    render: (text: any) => <T.TitleLableMoney>{moneyConvert(text, true)} 원</T.TitleLableMoney>
  },
  {
    title: ' ',
    dataIndex: 'date',
    width: '30%'
  }
]

const data: DataType[] = [
  {
    key: '1',
    date: '2023-05-31',
    money: 32000,
    address: 'New York Lake Park'
  },
  {
    key: '2',
    date: '2023-02-21',
    money: 42000,
    address: 'London No. 1 '
  },
  {
    key: '3',
    date: '2023-01-14',
    money: 14000,
    address: 'Sydney  Park'
  },
  {
    key: '4',
    date: '2023-05-31',
    money: 73000,
    address: 'No. 1 Lake Park'
  }
]

const TablePayment = (props: Props) => {
  const { onClick, className, children } = props
  const dispatch = useDispatch()
  const [dataDeposit, setDataDeposit] = useState<any>([])

  const getDataDeposit = async () => {
    dispatch({ type: 'WAITTING' })
    try {
      const res: any = await getListPayment({
        type: 'all',
        limit: '5'
      })
      // console.log(res.data);
      if (res.data) {
        let newData: any = []
        for (let i = 0; i < res?.data?.length; i++) {
          const item = {
            key: i,
            date: moment(res?.data[i].okdate).format('YYYY-MM-DD'),
            money: res?.data[i].money,
            name: res?.data[i].mb_name
          }
          newData = [...newData, item]
        }
        setDataDeposit(newData)
        dispatch({ type: 'STOP_WAITTING' })
      } else {
        alert(res.message)
        dispatch({ type: 'STOP_WAITTING' })
      }
    } catch (error) {
      console.log(error)
      dispatch({ type: 'STOP_WAITTING' })
    }
  }

  useEffect(() => {
    getDataDeposit()
  }, [])

  return (
    <T.Wrapper className={className}>
      {/* <S.Title>
        <div className='left'>
          <i className='fa fa-star m-r-10 text-danger'></i>
          <strong>실시간 출금</strong>
        </div>
      </S.Title> */}
      <Table columns={columns} dataSource={dataDeposit} pagination={false} />
    </T.Wrapper>
  )
}

export default TablePayment
